<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20.2 6">

    <path :class="shouldShowDrop(5)? 'full' : 'faded'"
          d="M2.1,37.571a.359.359,0,0,0-.349.259A6.557,6.557,0,0,1,.71,39.8a3.372,3.372,0,0,1,.5,1.683A2.731,2.731,0,0,1,.71,43.1a1.88,1.88,0,0,0,1.39.471,2.092,2.092,0,0,0,2.1-2.089c0-1.309-1.192-1.8-1.751-3.653A.357.357,0,0,0,2.1,37.571Z"
          transform="translate(16 -37.571)"/>
    <path :class="shouldShowDrop(4)? 'full' : 'faded'"
          d="M2.1,37.571a.359.359,0,0,0-.349.259A6.557,6.557,0,0,1,.71,39.8a3.372,3.372,0,0,1,.5,1.683A2.731,2.731,0,0,1,.71,43.1a1.88,1.88,0,0,0,1.39.471,2.092,2.092,0,0,0,2.1-2.089c0-1.309-1.192-1.8-1.751-3.653A.357.357,0,0,0,2.1,37.571Z"
          transform="translate(12 -37.571)"/>
    <path :class="shouldShowDrop(3)? 'full' : 'faded'"
          d="M2.1,37.571a.359.359,0,0,0-.349.259A6.557,6.557,0,0,1,.71,39.8a3.372,3.372,0,0,1,.5,1.683A2.731,2.731,0,0,1,.71,43.1a1.88,1.88,0,0,0,1.39.471,2.092,2.092,0,0,0,2.1-2.089c0-1.309-1.192-1.8-1.751-3.653A.357.357,0,0,0,2.1,37.571Z"
          transform="translate(8 -37.571)"/>
    <path :class="shouldShowDrop(2)? 'full' : 'faded'"
          d="M2.1,37.571a.359.359,0,0,0-.349.259A6.557,6.557,0,0,1,.71,39.8a3.372,3.372,0,0,1,.5,1.683A2.731,2.731,0,0,1,.71,43.1a1.88,1.88,0,0,0,1.39.471,2.092,2.092,0,0,0,2.1-2.089c0-1.309-1.192-1.8-1.751-3.653A.357.357,0,0,0,2.1,37.571Z"
          transform="translate(4 -37.571)"/>
    <path :class="shouldShowDrop(1)? 'full' : 'faded'"
          d="M2.1,37.571a.359.359,0,0,0-.349.259C1.192,39.679,0,40.181,0,41.483a2.1,2.1,0,0,0,4.2,0c0-1.309-1.192-1.8-1.751-3.653l-.117-.178Z"
          transform="translate(0 -37.571)"/>
  </svg>
</template>

<script>
  export default {
    name: "MoistureDrops",
    props: {
      "numDropsFilled": {
        type: Number,
        default: 5,
        validator: function (value) {
          // must be 1 - 5 inclusive
          return value >= 0 && value <= 5;
        },
        required: true
      },
      "width": {
        type: Number,
        default: 20
      }
    },
    methods: {
      shouldShowDrop(num) {
        return (num <= this.numDropsFilled);
      }
    },
    computed: {
      height() {
        return this.width * 6/20.2;
      }
    }
  }
</script>

<style scoped>
  .faded {
    fill: #fff;
    opacity:0.25;
  }
  .full {
    fill:#6cecff;
  }
</style>